import apiAthleteResults from '@/api/athlete-result'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteAthleteResultStart:
    '[delete athlete result] Delete athlete result start',
  deleteAthleteResultSuccess:
    '[delete athlete result] Delete athlete result success',
  deleteAthleteResultFailure:
    '[delete athlete result] Delete athlete result failure'
}

export const actionTypes = {
  deleteAthleteResult: '[delete athlete result] Delete athlete result'
}

const mutations = {
  [mutationTypes.deleteAthleteResultStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteAthleteResultSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteAthleteResultFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteAthleteResult](context, {id}) {
    context.commit(mutationTypes.deleteAthleteResultStart)
    return new Promise(resolve => {
      apiAthleteResults
        .deleteAthleteResult(id)
        .then(response => {
          context.commit(mutationTypes.deleteAthleteResultSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteAthleteResultFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
